import { render, staticRenderFns } from "./VAccountDesk.vue?vue&type=template&id=4aaeb130&"
import script from "./VAccountDesk.vue?vue&type=script&lang=ts&"
export * from "./VAccountDesk.vue?vue&type=script&lang=ts&"
import style0 from "./VAccountDesk.vue?vue&type=style&index=0&id=4aaeb130&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports